<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.telegram')" :title="'CR, FTD alerts!'">
      <div class="list__buttons">
        <div @click="sendConfig()" class="list__add-more">{{ $t("telegram.applySend") }}</div>
        <div @click="saveFilter()" class="list__add-more">{{ $t("common.save") }}</div>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div v-for="(filter, index) in list" :key="index" class="list__filter">
        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('language_id', [], index)"
              v-if="list[index].language_id.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="list[index].language_id.length > 0">
                  {{ list[index].language_id[0].code }}

                  <template v-if="list[index].language_id.length > 1">
                    +{{ list[index].language_id.length - 1 }}
                  </template>
                </template>
                <template v-else> Languages </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_languages" placeholder="Search Languages" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in list[index].language_id"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('language_id', item, index)"
                  >
                    {{ item.code }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('language_id', item, index)"
                  v-for="item in getCheckList('languagesList', 'search_languages', 'code')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.code }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration_type', [], index)"
              v-if="list[index].integration_type.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="list[index].integration_type.length > 0">
                  {{ list[index].integration_type[0].name }}

                  <template v-if="list[index].integration_type.length > 1">
                    +{{ list[index].integration_type.length - 1 }}
                  </template>
                </template>
                <template v-else> Type Integration </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in list[index].integration_type"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration_type', item, index)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('integration_type', item, index)"
                  v-for="item in integrationSpecialTypeList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration_cost_type', [], index)"
              v-if="list[index].integration_cost_type.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="list[index].integration_cost_type.length > 0">
                  {{ list[index].integration_cost_type[0].name }}

                  <template v-if="list[index].integration_cost_type.length > 1">
                    +{{ list[index].integration_cost_type.length - 1 }}
                  </template>
                </template>
                <template v-else> Cost Type Integration </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in list[index].integration_cost_type"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration_cost_type', item, index)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('integration_cost_type', item, index)"
                  v-for="item in costTypeList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="deleteFilter(index)" class="list__add-more">{{ $t("common.delete") }}</div>
      </div>
      <div @click="addFilter()" class="list__add-more">{{ $t("telegram.addFilterSet") }}</div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import leadApi from "~/api/lead";
import "vue2-datepicker/index.css";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "TelegramList",
  metaInfo() {
    return {
      title: this.$t("nav.telegramAlerts"),
    };
  },
  data() {
    return {
      search_languages: "",

      list: [],
      languagesList: [],

      integrationSpecialTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "In",
          id: "in",
        },
        {
          name: "Out",
          id: "out",
        },
      ],
      costTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "CPL",
          id: "cpl",
        },
        {
          name: "CPA",
          id: "cpa",
        },
      ],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    ModalError,
    //   MainModal
  },
  mounted() {
    this.getLanguage();
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess"]),
  },
  methods: {
    getCheckList(listKey, filterKey, nameKey) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      if (rawFilter == null || String(rawFilter).trim() === "") return arr;

      const filterStr = String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },

    getList() {
      this.$store.commit("lead/setLoading", true);

      leadApi
        .getTelegramConfig()
        .then((res) => {
          const list = res.data;

          list.forEach((element, index) => {
            const filter = element;
            const fullFilterLang = [];
            const fullIntegrationType = [];
            const fullIntegrationCostType = [];

            filter.language_id.forEach((el) => {
              const lang = this.languagesList.filter((item) => {
                return item.id == el;
              });
              fullFilterLang.push(lang[0]);
            });

            filter.integration_type.forEach((el) => {
              const lang = this.integrationSpecialTypeList.filter((item) => {
                return item.id == el;
              });
              fullIntegrationType.push(lang[0]);
            });

            filter.integration_cost_type.forEach((el) => {
              const lang = this.costTypeList.filter((item) => {
                return item.id == el;
              });
              fullIntegrationCostType.push(lang[0]);
            });

            list[index].language_id = fullFilterLang;
            list[index].integration_type = fullIntegrationType;
            list[index].integration_cost_type = fullIntegrationCostType;
          });

          this.list = list;

          console.log(this.list);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },

    saveFilter() {
      this.$store.commit("lead/setLoading", true);

      const data = [];

      this.list.forEach((element) => {
        const filterLang = [];
        const integrationType = [];
        const integrationCostType = [];

        element.language_id.forEach((el) => {
          filterLang.push(el.id);
        });

        element.integration_type.forEach((el) => {
          integrationType.push(el.id);
        });

        element.integration_cost_type.forEach((el) => {
          integrationCostType.push(el.id);
        });

        data.push({
          language_id: filterLang,
          integration_type: integrationType,
          integration_cost_type: integrationCostType,
        });
      });

      const send = {
        config: data,
      };

      leadApi
        .saveTelegramConfig(send)
        .then((res) => {
          this.getList();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },
    sendConfig() {
      this.$store.commit("lead/setLoading", true);

      leadApi
        .sendTelegramConfig()
        .then((res) => {
          this.getList();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },

    async getLanguage() {
      await leadApi
        .getLanguageList()
        .then((res) => {
          this.languagesList = res.data.items;
          this.getList();
        })
        .catch((error) => {})
        .finally(() => {});
    },

    addCheckElement(key, value, index) {
      const foundObj = this.list[index][key].find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.list[index][key].push(value);
      }
    },
    removeCheckElement(key, value, index) {
      this.list[index][key] = this.list[index][key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset, index) {
      this.list[index][key] = reset;
    },
    addFilter() {
      this.list.push({
        language_id: [],
        integration_type: [],
        integration_cost_type: [],
      });
    },
    deleteFilter(index) {
      this.list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 100;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  display: grid;
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 2fr 1fr 1fr !important;
}

/deep/.modal-container {
  height: fit-content;
  max-height: 90vh;
  overflow-y: auto;
}

.list {
  &__buttons {
    display: flex;
  }
  &__add-more {
    width: fit-content;
    padding: 10px 20px;
    background: #3c2a1e;
    color: #fff;
    border-radius: 10px;
    font-weight: 700;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  &__table-title {
    padding: 20px 0 10px;
    font-size: 24px;
    font-weight: 700;
  }
  &__filter-favorite {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    font-size: 18px;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }

    .inner {
      fill: #fff !important;
    }
    .border {
      stroke: rgb(148, 22, 22) !important;
      fill: none !important;
    }

    &.active {
      .inner {
        fill: rgb(148, 22, 22) !important;
      }
    }
  }
  &__confirm-log {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid gainsboro;
    margin-bottom: 10px;
  }

  &__confirm-log-type {
    padding: 20px;
    background: gainsboro;
    border-radius: 10px;
    margin-right: 10px;
  }

  &__confirm-log-time {
    margin-left: auto;
    padding-left: 10px;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
